export default "__VITE_ASSET__l0k$RLJw__"